import useTenant from "./hooks/useTenant";

export const GlobalTenantBanner = () => {
    const { tenantInactive }: any = useTenant();

    if (!tenantInactive) return null;

    return (
        <div className="bg-yellow-100 border border-yellow-400 text-yellow-800 px-4 py-3 text-center font-medium">
            ⚠️ Your subscription is inactive. Please contact your administrator for assistance.
        </div>
    );
};
